var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.69231L5 8.82224L19 8.82224V7.69231C19 6.94885 18.3973 6.34615 17.6538 6.34615H16.1594V5.43961C16.1594 5.19682 15.9626 5 15.7198 5C15.477 5 15.2802 5.19682 15.2802 5.43961V6.34615L8.31401 6.34615V5.43961C8.31401 5.19682 8.11719 5 7.8744 5C7.6316 5 7.43478 5.19682 7.43478 5.43961V6.34615H6.34615C5.60269 6.34615 5 6.94885 5 7.69231ZM5 17.6538L5 9.75967L19 9.75967V17.6538C19 18.3973 18.3973 19 17.6538 19H6.34615C5.60269 19 5 18.3973 5 17.6538ZM14.8269 11.4615L16.7115 11.4615V13.3462H14.8269L14.8269 11.4615ZM16.7115 15.3654H14.8269V17.25H16.7115V15.3654ZM11.1923 11.4615H13.0769L13.0769 13.3462L11.1923 13.3462V11.4615ZM13.0769 15.3654L11.1923 15.3654L11.1923 17.25H13.0769V15.3654ZM7.28846 11.4615H9.17308V13.3462H7.28846V11.4615ZM9.17308 15.3654H7.28846V17.25H9.17308L9.17308 15.3654Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.7778574aa25ddc9644bba21ad698aadb.svg";
export { ForwardRef as ReactComponent };